<script setup>
import { ref } from "vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head } from '@inertiajs/inertia-vue3';
import BaseButton from "@/Components/BaseButton.vue";
import BreezeNavLink from '@/Components/NavLink.vue';
import { mdiPlusCircle } from "@mdi/js";
import { Icon } from "@iconify/vue";
import TableFilter from "@/Components/TableFilter.vue";
import Buttons from "@/Components/Buttons.vue";
import Dropdown from "@/Components/Dropdown.vue";
import DropdownLink from "@/Components/DropdownLink.vue";
import SelectSearch from "@/Components/SelectSearch.vue";
import BaseIcon from "@/Components/BaseIcon.vue";
import PageHeader from '@/Components/PageHeader.vue';

const props = defineProps({
    complaints: Array
});

const mapOptionsLocal = (obj) => {
    if (!obj) return undefined;
    if (Object.keys(obj).length === 0) return undefined;
    if (Array.isArray(obj)) return obj.map(o => ({ value: isNaN(o.value) ? o.value : Number(o.value), label: o.label }));
    return Object.entries(obj).map(([key, value]) => ({
        value: isNaN(key) ? key : Number(key),
        label: value
    }));
};

const typeGoodsOptions = { 0: 'Producto', 1: 'Servicio' };
const typeComplaintOptions = { 0: 'Reclamo', 1: 'Queja' };
const statusOptions = { 0: 'Pendiente', 1: 'En Proceso', 2: 'Resuelto' };

const columnas = ref([
    { key: 'actions', label: 'Acciones', align: 'center' },
    { key: 'type_complaint', label: 'Tipo', filterType: 'select', filterOptions: mapOptionsLocal(typeComplaintOptions), filterColor: [{ value: 0, color: 'red' }, { value: 1, color: 'black' }], align: 'center' },
    { key: 'correlative', label: 'N° de Reclamo', align: 'center', filterType: 'text' },
    { key: 'document_type', label: 'Tipo Doc.', align: 'center' },
    { key: 'document_number', label: 'DNI / RUC', align: 'center' },
    { key: 'customer_name', label: 'Cliente', align: 'left' },
    { key: 'phone', label: 'Celular', align: 'center' },
    { key: 'email', label: 'Correo Electrónico', align: 'left', nowrap: true },
    { key: 'type_goods', label: 'Tipo de Bien', filterType: 'select', filterOptions: mapOptionsLocal(typeGoodsOptions), filterColor: [{ value: 0, color: 'green' }, { value: 1, color: 'blue' }], align: 'center' },
    { key: 'amount', label: 'Monto', align: 'right' },
    { key: 'created_at', label: 'Fecha', align: 'center', filterType: 'date' },
    { key: 'status', label: 'Estado', filterType: 'select', filterOptions: mapOptionsLocal(statusOptions), filterColor: [{ value: 0, color: 'gray' }, { value: 1, color: 'orange' }, { value: 2, color: 'green' }], align: 'center', nowrap: true },
]);

const tab = ref(0);
const rutaPrefijo = ref('ecommerceclaim');

</script>

<template>

    <Head title="Lista de Reclamos" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PageHeader title="Reclamos o Quejas" subtitle="Solicitudes de clientes">
                <template #actions>
                    <Buttons :href="route('dashboard')" color="primary" size="header" icon="mdi:arrow-u-left-top-bold" label="Volver al Inicio" :hideLabelOnMobile="true" />
                </template>
            </PageHeader>
        </template>

        

        <div class="py-8 lg:py-10">
            <div v-if="tab == 0" class="sm:px-6 lg:px-8 px-4 mx-auto pb-4">
                <div class="lg:col-span-4 bg-white rounded-md shadow-lg border p-4">
                    <TableFilter :data="props.complaints" :columns="columnas" :title="'Listado Reclamos o Quejas'" manage-columns checkable exporteable :ruta="rutaPrefijo">
                        <template #cell-correlative="{ item }">
                            <a :href="route(rutaPrefijo + '-card', { id: item.id })" class="text-blue-500 hover:text-blue-700 font-medium cursor-pointer">
                                {{ item.correlative }}
                            </a>
                        </template>
                        <template #cell-actions="{ item }">
                            <div class="flex flex-row justify-center gap-2">
                                <Dropdown align="Right" width="48">
                                    <template #trigger>
                                        <Buttons size="iconSm" color="light" title="Ver">
                                            <Icon icon="tabler:dots-vertical" class="text-slate-500 dark:text-slate-400" />
                                        </Buttons>
                                    </template>
                                    <template #content>
                                        <div class="px-2 py-1 text-xs font-semibold text-gray-500 dark:text-slate-400 uppercase tracking-wider border-b border-slate-100 dark:border-slate-700 mb-1">
                                            Acciones
                                        </div>
                                        <DropdownLink :href="route(rutaPrefijo + '-card', { id: item.id })" class="flex items-center gap-2">
                                            <Icon icon="tabler:eye" class="text-gray-700 dark:text-slate-300" />
                                            <span class="dark:text-slate-200">Ver Ficha</span>
                                        </DropdownLink>
                                    </template>
                                </Dropdown>
                            </div>
                        </template>
                    </TableFilter>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
